module.exports = __webpack_public_path__ + "img/E20-ecuador.f7fbe426.png";